
/*
	By default, Angular runs in debug mode, which adds some assertion checks, but also runs ChangeDetection twice each time to ensure there are no unexpected changes to binding values.
	To call ChangeDetection only once, you need to enable production mode by adding the following code to your Angular app:
 */

export const environment = {
	production: true,
	api: 'api/sherpa.json',
	authApi: 'sherpa-remote/auth/',
	baseregApi: 'sherpa-remote/basereg/'
};
